import { createSelector } from '@reduxjs/toolkit';
import { selectIsSuburbanListing } from '../jsonQuery';
import { selectLocation } from './selectLocation';

export const selectHasRegionalDistricts = createSelector(
  [selectLocation, selectIsSuburbanListing],
  (currentLocation, isSuburban) =>
    isSuburban &&
    (currentLocation === 'moscow_mo' || currentLocation === 'spb_lo' || currentLocation.hasRegionalDistricts),
);
